<template>
  <a
    :href="link"
    target="_blank"
    class="instagram-link"
    @click="transitionToInstagram">
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="instagram-icon">
      <g clip-path="url(#clip0)">
        <!--eslint-disable max-len-->
        <path
          d="M10.2001 0.600006H3.80026C2.04046 0.600006 0.600342 2.04013 0.600342 3.79993V10.2001C0.600342 11.9594 2.04046 13.4 3.80026 13.4H10.2001C11.9599 13.4 13.4 11.9594 13.4 10.2001V3.79993C13.4 2.04013 11.9599 0.600006 10.2001 0.600006ZM12.3333 10.2001C12.3333 11.3761 11.3767 12.3333 10.2001 12.3333H3.80026C2.62414 12.3333 1.66703 11.3761 1.66703 10.2001V3.79993C1.66703 2.62364 2.62414 1.6667 3.80026 1.6667H10.2001C11.3767 1.6667 12.3333 2.62364 12.3333 3.79993V10.2001Z"
          fill="white" />
        <path
          d="M10.4672 4.33318C10.909 4.33318 11.2672 3.97501 11.2672 3.5332C11.2672 3.09138 10.909 2.73322 10.4672 2.73322C10.0254 2.73322 9.66724 3.09138 9.66724 3.5332C9.66724 3.97501 10.0254 4.33318 10.4672 4.33318Z"
          fill="white" />
        <path
          d="M6.99997 3.79993C5.23233 3.79993 3.80005 5.23236 3.80005 6.99985C3.80005 8.76669 5.23233 10.2001 6.99997 10.2001C8.76711 10.2001 10.1999 8.76669 10.1999 6.99985C10.1999 5.23236 8.76711 3.79993 6.99997 3.79993ZM6.99997 9.1334C5.8219 9.1334 4.86674 8.17823 4.86674 6.99985C4.86674 5.82147 5.8219 4.86662 6.99997 4.86662C8.17803 4.86662 9.1332 5.82147 9.1332 6.99985C9.1332 8.17823 8.17803 9.1334 6.99997 9.1334Z"
          fill="white" />
        <!--eslint-enable max-len-->
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="12.8"
            height="12.8"
            fill="white"
            transform="translate(0.600098 0.600006)" />
        </clipPath>
      </defs>
    </svg>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';
import MobileAppMessagingDriver from 'Root/drivers/MobileAppMessagingDriver';

export default {
  name: 'Instagram',

  data() {
    return {
      link: 'https://www.instagram.com/skycoach.gg/',
    };
  },

  computed: {
    ...mapGetters(['isPlatformApp']),
  },

  methods: {
    transitionToInstagram(event) {
      if (this.isPlatformApp) {
        event.preventDefault();
        MobileAppMessagingDriver.openUrl(this.link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .instagram-link {
    --circle-bg-color: #{$color--basic-dark-gray};
    --circle-size: 40px;
    --icon-size: 16px;

    display: flex;
    width: var(--circle-size);
    height: var(--circle-size);
    justify-content: center;
    align-items: center;
    background-color: var(--circle-bg-color);
    border-radius: 50%;
  }

  .instagram-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }
</style>
